module.exports = __webpack_public_path__ + "assets/img/01b1-cn.svg";